import { post } from '@/libs/http';
import { Web3LoginReq, Web3LoginRes } from "@/types/api/user-auth/web3-login.d";
import { createApiMutationHook } from '@/hooks/use-api-mutation';
import { Web3LoginType, LoginDeviceType, LoginStatusType } from '@/const/login';

export interface CustomWeb3LoginRes extends Omit<Web3LoginRes, 'loginStatus'> {
  loginStatus?: LoginStatusType;
}

export const postWeb3Login = ({
  params,
}: {
  params: Omit<Web3LoginReq, 'loginType' | 'loginDeviceType'> & {
    loginType: (typeof Web3LoginType)[keyof typeof Web3LoginType];
    loginDeviceType: (typeof LoginDeviceType)[keyof typeof LoginDeviceType];
  };
}) => {
  return post<CustomWeb3LoginRes>('/user/auth/v1/web3/login', params);
};

export const usePostWeb3Login = createApiMutationHook(postWeb3Login);